import React from "react";
import { Link } from "react-router-dom";

export default function Legal({ tipo }) {
  const privacy = tipo === "privacidade";
  return (
    <main className="app-conteudo legal">
      <Link to="/">← DiárioMed</Link>
      <p className="sobretitulo">DiárioMed</p>
      <h1>{privacy ? "Privacidade" : "Termos de uso"}</h1>
      <p><strong>Documento em elaboração.</strong> Antes de disponibilizar o produto para uso real, publique os dados legais da empresa/controlador, canais de contato, bases legais, prazos de retenção, direitos dos titulares, subprocessadores e política de atendimento a incidentes.</p>
      <p>O DiárioMed organiza registros informados pelo paciente para compartilhamento com o profissional responsável. Não oferece diagnóstico, triagem de emergência ou recomendação clínica automatizada.</p>
      {privacy && <p>As páginas públicas usam o Tracking Hub para medir visitas. O identificador de visitante por cookie está desativado e o script não é carregado nas telas de acesso, nos acompanhamentos profissionais ou nas páginas de registro do paciente. A opção “Não rastrear” do navegador também é respeitada.</p>}
      <p>Não insira dados reais de pacientes até a revisão jurídica e de segurança desta política.</p>
    </main>
  );
}
